export function translateVerificationError(detail: any): string {
  if (!detail) return 'Неизвестная ошибка';
  if (typeof detail === 'string') return translateCode(detail);

  if (typeof detail === 'object') {
    const code = detail.error || detail.detail || '';
    const retryIn = detail.retry_in;
    // Готовый текст от бэка важнее наших кодов — патч kycfix, 08.07.2026.
    const message = detail.message;
    if (message && retryIn) return `${message} Повтор через ${retryIn} сек.`;
    if (message) return message;
    if (code === 'COOLDOWN' && retryIn) {
      return `Подождите ещё ${retryIn} сек. перед повторной отправкой.`;
    }
    if (code) return translateCode(String(code));
    return JSON.stringify(detail);
  }
  return String(detail);
}

function translateCode(code: string): string {
  const upper = code.toUpperCase();
  if (upper.includes('FLOOD_WAIT')) {
    return 'Слишком много запросов. Подождите чуть-чуть и попробуйте ещё раз.';
  }
  if (upper === 'COOLDOWN') return 'Код уже отправлен. Подождите немного перед повторной отправкой.';
  if (upper === 'DAILY_LIMIT_REACHED') return 'Превышен дневной лимит отправок. Попробуйте завтра.';
  if (upper === 'INVALID_CODE') return 'Неверный код.';
  if (upper === 'CODE_EXPIRED' || upper === 'SESSION_EXPIRED') return 'Срок действия кода истёк. Запросите новый.';
  if (upper === 'TOO_MANY_ATTEMPTS' || upper === 'MAX_ATTEMPTS_REACHED')
    return 'Превышено число попыток. Запросите новый код.';
  if (upper === 'INVALID_PHONE_FORMAT') return 'Некорректный формат номера.';
  if (upper === 'NO_EMAIL') return 'Укажите email.';
  if (upper === 'PHONE_NOT_PROVIDED') return 'Укажите номер телефона.';
  if (upper === 'NO_ACTIVE_CODE') return 'Нет активного кода. Запросите новый.';
  if (upper === 'CODE_NOT_SENT') return 'Код ещё не отправлен.';
  if (upper.startsWith('SEND_FAILED')) return 'Не удалось отправить код. Попробуйте позже.';
  if (upper === 'CANNOT_SEND') return 'Не удалось отправить код на этот номер.';
  return code;
}
